import VehicleBlockShellCapShip from './VehicleBlockShellCapShip';

export default VehicleBlockShellCapShip;
export { VehicleBlockShellCapShip };
